/**
 * Dashboard admin translations: admin (home, compliance, fulfillment, webhook, users, domains, products, migration, features)
 */

export const admin = {
  home: {
    title: 'Admin-Home'
  },
  compliance: {
    title: 'NIS2 Compliance',
    subtitle: 'Verwalte Offenlegungsanfragen, Missbrauchsfälle und Domain-Sperrungen',
    fetchError: 'Compliance-Daten konnten nicht geladen werden',
    expired: 'abgelaufen',
    cards: {
      disclosure: {
        title: 'Offenlegungsanfragen',
        description: 'Ausstehende Anfragen von Behörden und Rechtsanwälten'
      },
      abuse: {
        title: 'Missbrauchsfälle',
        description: 'Gemeldete Spam-, Phishing- und Malware-Fälle'
      },
      suspended: {
        title: 'Gesperrte Domains',
        description: 'Domains mit aktiver Sperrung'
      },
      handles: {
        title: 'Verifizierungen',
        description: 'Kontakte mit ausstehender oder abgelaufener Verifizierung'
      },
      terms: {
        title: 'AGB-Zustimmungen',
        description: 'Konten mit Verträgen, für die noch eine ältere Fassung gilt'
      }
    },
    info: {
      title: 'NIS2-Informationen',
      description: 'NIS2 Artikel 28 verpflichtet Domain-Registrare zur Verifizierung und Offenlegung von Kontaktdaten.',
      point1: 'Offenlegungsanfragen von Behörden müssen innerhalb von 72 Stunden bearbeitet werden',
      point2: 'Kontaktdaten müssen auf Richtigkeit überprüft und bei Verstoß aktualisiert werden',
      point3: 'Bei Missbrauch können Domains temporär suspendiert werden'
    },
    termsPending: {
      title: 'Ausstehende AGB-Zustimmungen',
      subtitle: 'Konten mit laufenden Verträgen, für die noch eine ältere Fassung der AGB gilt',
      refresh: 'Aktualisieren',
      measuredAgainst: 'Gemessen an der Fassung vom {date}',
      noMaterialVersion: 'Es ist keine zustimmungsbedürftige Fassung veröffentlicht.',
      manualNote: 'Eine Kündigung ohne Zustimmung ist eine Einzelfallentscheidung und wird hier nicht ausgelöst.',
      searchPlaceholder: 'E-Mail, Name oder Konto-ID suchen...',
      empty: 'Keine ausstehenden Zustimmungen',
      fetchError: 'Die Liste konnte nicht geladen werden',
      beforeFirstVersion: 'vor der ersten erfassten Fassung',
      none: 'keine',
      notNotified: 'nicht benachrichtigt',
      columns: {
        account: 'Konto',
        governing: 'Geltende Fassung',
        accepted: 'Zugestimmt',
        notified: 'Benachrichtigt',
        days: 'Tage seit',
        contracts: 'Verträge'
      }
    },
    disclosure: {
      title: 'Offenlegungsanfragen',
      subtitle: 'Anfragen zur Offenlegung von Domain-Kontaktdaten',
      create: 'Neue Anfrage',
      searchPlaceholder: 'Domain oder Antragsteller suchen...',
      empty: 'Keine Offenlegungsanfragen',
      emptyDescription: 'Es liegen keine offenen Anfragen vor.',
      columns: {
        created: 'Erstellt',
        domain: 'Domain',
        requester: 'Antragsteller',
        deadline: 'Frist',
        status: 'Status'
      },
      pagination: {
        showing: 'Zeige {from} - {to} von {total}'
      }
    },
    abuse: {
      title: 'Missbrauchsfälle',
      subtitle: 'Gemeldete Verstöße und Missbrauchsfälle',
      searchPlaceholder: 'Domain oder Melder suchen...',
      empty: 'Keine Missbrauchsfälle',
      emptyDescription: 'Es gibt derzeit keine offenen Missbrauchsmeldungen.',
      columns: {
        date: 'Datum',
        domain: 'Domain',
        category: 'Kategorie',
        reporter: 'Melder',
        status: 'Status'
      },
      pagination: {
        showing: 'Zeige {from} - {to} von {total}'
      },
      detail: {
        title: 'Missbrauchsfall',
        subtitle: 'Fall #{id}',
        save: 'Speichern',
        caseInfo: 'Fallinformationen',
        created: 'Erstellt am',
        category: 'Kategorie',
        currentStatus: 'Aktueller Status',
        domain: 'Domain',
        domainName: 'Domain-Name',
        reporter: 'Melder',
        reporterEmail: 'E-Mail',
        reporterName: 'Name',
        description: 'Beschreibung',
        actions: 'Bearbeitung',
        newStatus: 'Neuer Status',
        resolutionNote: 'Bearbeitungsnotiz',
        resolutionPlaceholder: 'Optional: Notizen zur Bearbeitung oder Lösung des Falls...',
        resolution: 'Lösung',
        resolvedAt: 'Gelöst am',
        resolvedBy: 'Bearbeitet von',
        notFound: 'Fall nicht gefunden',
        notFoundDescription: 'Der angeforderte Missbrauchsfall konnte nicht gefunden werden.',
        backToList: 'Zurück zur Übersicht'
      }
    },
    suspended: {
      title: 'Gesperrte Domains',
      subtitle: 'Domains mit aktiver Sperrung verwalten',
      searchPlaceholder: 'Domain suchen...',
      empty: 'Keine gesperrten Domains',
      emptyDescription: 'Derzeit sind keine Domains gesperrt.',
      unsuspend: 'Entsperren',
      unsuspendSuccess: 'Domain entsperrt',
      unsuspendError: 'Fehler beim Entsperren',
      columns: {
        domain: 'Domain',
        suspendedAt: 'Gesperrt am',
        reason: 'Grund',
        suspendedBy: 'Durch',
        owner: 'Inhaber'
      }
    },
    handles: {
      title: 'Handle-Revalidierung',
      subtitle: 'Kontakte mit ausstehender oder abgelaufener Verifizierung',
      searchPlaceholder: 'E-Mail oder Name suchen...',
      filterAll: 'Alle',
      filterPending: 'Ausstehend',
      filterExpired: 'Abgelaufen',
      empty: 'Keine offenen Verifizierungen',
      emptyDescription: 'Alle Kontakte sind verifiziert oder haben keine Frist.',
      revalidate: 'Revalidieren',
      revalidateSuccess: 'Revalidierung gesendet',
      revalidateError: 'Fehler bei Revalidierung',
      days: 'Tage',
      expired: 'Abgelaufen',
      columns: {
        handle: 'Kontakt',
        type: 'Typ',
        email: 'E-Mail',
        phone: 'Telefon',
        deadline: 'Frist'
      }
    }
  },
  fulfillment: {
    title: 'Fulfillment Monitor',
    subtitle: 'Bestellungen verwalten und Fulfillment überwachen',
    fetchError: 'Fulfillment-Daten konnten nicht geladen werden',
    thresholdInfo: 'Carts gelten als hängend nach {threshold}',
    tabs: {
      orders: 'Bestellungen',
      stuck: 'Hängende Carts',
      tasks: 'Tasks'
    },
    orders: {
      title: 'Bestellungen',
      subtitle: '{count} Bestellungen insgesamt',
      loading: 'Lade Bestellungen...',
      filters: {
        status: 'Status',
        allStatuses: 'Alle Status',
        accountId: 'Account-ID',
        accountIdPlaceholder: 'Account-ID eingeben...',
        cartId: 'Cart ID',
        cartIdPlaceholder: 'UUID eingeben...',
        clear: 'Filter zurücksetzen'
      },
      table: {
        cartId: 'Cart ID',
        customer: 'Kunde',
        status: 'Status',
        updated: 'Aktualisiert',
        items: 'Artikel',
        itemCount: 'ein Artikel | {count} Artikel'
      },
      status: {
        started: 'Gestartet',
        open: 'Offen',
        payment_processing: 'Zahlung läuft',
        payment_failed: 'Zahlung fehlgeschlagen',
        payment_canceled: 'Zahlung abgebrochen',
        pending_fulfillment: 'Wartet auf Fulfillment',
        partial_fulfillment: 'Teilweise erfüllt',
        fulfillment: 'Im Fulfillment',
        done: 'Abgeschlossen',
        refunded: 'Erstattet'
      },
      billingFreq: {
        monthly: 'Monatlich',
        quarterly: 'Vierteljährlich',
        'half-annually': 'Halbjährlich',
        annually: 'Jährlich',
        free: 'Kostenlos'
      },
      details: {
        items: 'Artikel',
        noItems: 'Keine Artikel im Warenkorb',
        payment: 'Zahlung',
        paymentId: 'Payment ID',
        created: 'Erstellt',
        paidAt: 'Bezahlt am',
        refundedAt: 'Erstattet am',
        refundReason: 'Erstattungsgrund',
        notRefundable: 'Erstattung nur für bezahlte Bestellungen möglich'
      },
      empty: {
        title: 'Keine Bestellungen gefunden',
        filtered: 'Versuche andere Filter',
        none: 'Noch keine Bestellungen vorhanden'
      },
      pagination: {
        showing: 'Zeige {from}-{to} von {total}',
        page: 'Seite {page} von {pages}'
      }
    },
    cards: {
      stuck: {
        title: 'Hängende Carts',
        description: 'Warenkörbe im Fulfillment-Prozess blockiert'
      },
      failed: {
        title: 'Fehlgeschlagene Tasks',
        description: 'Tasks mit Fehlerstatus'
      },
      webhook: {
        title: 'Webhook Monitor',
        description: 'Zu Stripe Webhook-Ereignissen wechseln'
      }
    },
    refund: {
      button: 'Erstatten',
      refunded: 'Erstattet',
      dialogTitle: 'Warenkorb erstatten',
      dialogMessage: 'Der gesamte Warenkorb wird über Stripe erstattet und als erstattet markiert.',
      warning: 'Die Stripe-Erstattung wird sofort ausgelöst und kann nicht rückgängig gemacht werden.',
      reasonLabel: 'Grund',
      reasonPlaceholder: 'Grund für die Erstattung...',
      confirm: 'Erstatten',
      success: 'Erstattung ausgelöst'
    }
  },
  webhook: {
    title: 'Webhook Monitor',
    subtitle: 'Stripe Webhook-Ereignisse überwachen und wiederholen',
    fetchError: 'Webhook-Events konnten nicht geladen werden',
    retry: 'Wiederholen',
    retrySuccess: 'Webhook wurde zur Wiederholung eingereiht',
    retryError: 'Fehler beim Wiederholen des Webhooks',
    confirmRetry: {
      title: 'Webhook erneut verarbeiten?',
      message: 'Das Webhook-Event wird erneut zur Verarbeitung eingereiht.',
      confirm: 'Wiederholen',
      cancel: 'Abbrechen'
    }
  },
  users: {
    title: 'Benutzerverwaltung',
    subtitle: 'Verwalte alle Benutzer und Zugriffsrechte',
    newUser: 'Neuer Benutzer',
    loading: 'Benutzer werden geladen...',
    table: {
      users: 'Benutzer',
      usersActive: '{total} Benutzer, {active} aktiv',
      search: 'Suchen...',
      name: 'Name',
      email: 'E-Mail',
      type: 'Typ',
      role: 'Rolle',
      status: 'Status',
      actions: 'Aktionen',
      edit: 'Bearbeiten',
      toggleStatus: 'Status umschalten'
    },
    filters: {
      active: '{count} Aktiv',
      inactive: '{count} Inaktiv',
      unverified: '{count} Unverifiziert',
      admins: '{count} Admins',
      reseller: '{count} Reseller',
      customers: '{count} Kunden'
    },
    empty: {
      noUsers: 'Keine Benutzer vorhanden',
      noResults: 'Keine Benutzer gefunden für "{query}"',
      noResultsFilter: 'Keine {filter}Benutzer für "{query}"',
      noFilterResults: 'Keine {filter} vorhanden',
      activeUsers: 'aktiven ',
      inactiveUsers: 'inaktiven ',
      unverifiedUsers: 'unverifizierten ',
      adminUsers: 'Admin-',
      resellerUsers: 'Reseller-',
      customerUsers: 'Kunden-',
      activeFilter: 'aktiven Benutzer',
      inactiveFilter: 'inaktiven Benutzer',
      unverifiedFilter: 'Benutzer mit unverifizierter E-Mail',
      adminsFilter: 'Admins',
      resellersFilter: 'Reseller',
      customersFilter: 'Kunden'
    },
    types: {
      person: 'Person',
      organization: 'Organisation'
    },
    notifications: {
      activated: '{name}: Aktiviert',
      deactivated: '{name}: Deaktiviert'
    },
    syncStripe: {
      button: 'Stripe synchronisieren',
      dialogTitle: 'Stripe synchronisieren',
      dialogMessage: 'Zahlungsmethoden synchronisieren und fehlende Subscriptions für diesen Account erstellen?',
      success: 'Stripe-Sync erfolgreich',
      successDetail: '{methods} Zahlungsmethode(n), {subs} Subscription(s) erstellt'
    },
    impersonate: {
      button: 'Impersonieren',
      dialogTitle: 'Benutzer impersonieren',
      dialogMessage: 'Du wirst als dieser Benutzer angemeldet und siehst das Dashboard aus dessen Perspektive.',
      warning: 'Sicherheitsrelevante Aktionen (Passwort, 2FA, Zahlungsmethoden) sind während einer Impersonation nicht möglich.',
      confirm: 'Impersonieren'
    },
    deactivate: {
      button: 'Deaktivieren',
      dialogTitle: 'Account deaktivieren',
      dialogMessage: 'Der Account wird deaktiviert und der Login gesperrt.',
      warning: 'Alle aktiven Sitzungen werden sofort beendet und der Benutzer kann sich nicht mehr anmelden.',
      reasonLabel: 'Grund',
      reasonPlaceholder: 'Grund für die Deaktivierung...',
      confirm: 'Deaktivieren',
      success: 'Account deaktiviert'
    },
    emailVerified: 'E-Mail verifiziert',
    pagination: {
      showing: 'Zeige {from} - {to} von {total}'
    },
    edit: {
      newUser: 'Neuer Benutzer',
      editUser: 'Benutzer bearbeiten',
      createUser: 'Neuen Benutzer erstellen',
      editUserData: 'Benutzerdaten bearbeiten',
      saveAndNew: 'Speichern & Neu',
      save: 'Speichern',
      status: 'Status',
      active: 'Aktiv',
      inactive: 'Inaktiv',
      emailVerified: 'E-Mail verifiziert',
      twoFactorActive: '2FA aktiviert',
      accountType: 'Kontotyp',
      accountTypeLabel: 'Kontotyp*',
      person: 'Person',
      organization: 'Organisation',
      role: 'Rolle*',
      customer: 'Kunde',
      reseller: 'Reseller',
      admin: 'Admin',
      contactData: 'Kontaktdaten',
      email: 'E-Mail*',
      emailPlaceholder: "email{'@'}beispiel.de",
      phone: 'Telefon*',
      phonePlaceholder: '+49 123 456789',
      companyData: 'Unternehmensdaten',
      personalData: 'Persönliche Daten',
      companyName: 'Firmenname*',
      companyPlaceholder: 'Firma GmbH',
      firstName: 'Vorname*',
      firstNameContact: 'Ansprechpartner Vorname',
      firstNamePlaceholder: 'Max',
      lastName: 'Nachname*',
      lastNameContact: 'Ansprechpartner Nachname',
      lastNamePlaceholder: 'Mustermann',
      vatId: 'USt-IdNr.',
      vatIdPlaceholder: 'DE123456789',
      address: 'Adresse',
      street: 'Straße und Hausnummer*',
      streetPlaceholder: 'Musterstraße 123',
      addressSupplement: 'Adresszusatz',
      addressSupplementPlaceholder: 'Gebäude, Etage, etc.',
      postcode: 'PLZ*',
      postcodePlaceholder: '12345',
      city: 'Stadt*',
      cityPlaceholder: 'Berlin',
      state: 'Bundesland*',
      stateSelect: 'Auswählen...',
      country: 'Land (ISO)*',
      countryPlaceholder: 'DE',
      countrySelect: 'Land auswählen...',
      limits: 'Limits',
      maxTeamMembers: 'Max. Teammitglieder',
      maxSubCustomers: 'Max. Unterkunden',
      validation: {
        emailRequired: 'E-Mail ist erforderlich',
        emailInvalid: 'Ungültige E-Mail-Adresse',
        phoneRequired: 'Telefon ist erforderlich',
        nameRequired: 'Name ist erforderlich',
        surnameRequired: 'Nachname ist erforderlich',
        companyRequired: 'Firmenname ist erforderlich',
        streetRequired: 'Adresse ist erforderlich',
        cityRequired: 'Stadt ist erforderlich',
        postcodeRequired: 'Postleitzahl ist erforderlich',
        stateRequired: 'Bundesland ist erforderlich',
        countryRequired: 'Ländercode ist erforderlich',
        countryMaxLength: 'Max. 2 Zeichen',
        validationError: 'Validierungsfehler',
        checkFields: 'Bitte überprüfe die markierten Felder'
      },
      notifications: {
        created: 'Benutzer erstellt',
        updated: 'Benutzer aktualisiert'
      }
    },
    detail: {
      back: 'Zurück zur Benutzerliste',
      tabs: {
        overview: 'Übersicht',
        sessions: 'Sitzungen',
        roles: 'Rollen',
        subAccounts: 'Unterkonten'
      },
      sessions: {
        title: 'Aktive Sitzungen',
        device: 'Gerät',
        location: 'Standort',
        created: 'Erstellt',
        status: 'Status',
        validated: 'Verifiziert',
        notValidated: 'OTP ausstehend',
        current: 'Aktuell',
        revoke: 'Widerrufen',
        revokeAll: 'Alle widerrufen',
        revokeConfirm: 'Diese Sitzung widerrufen?',
        revokeAllConfirm: 'Alle Sitzungen dieses Benutzers beenden? Der Benutzer wird überall abgemeldet.',
        revokeSuccess: 'Sitzung widerrufen',
        revokeAllSuccess: '{count} Sitzung(en) widerrufen',
        empty: 'Keine aktiven Sitzungen',
        unknownLocation: 'Unbekannt',
        unknownDevice: 'Unbekanntes Gerät'
      }
    }
  },
  domains: {
    title: 'Alle Domains',
    subtitle: 'Alle Domains im System verwalten',
    searchPlaceholder: 'Domain suchen...',
    status: {
      all: 'Alle',
      active: 'Aktiv',
      pendingDelete: 'Gekündigt',
      deleted: 'Gelöscht',
      tradeOut: 'Trade-Out',
      external: 'Extern',
      suspended: 'Gesperrt',
      transferPending: 'Transfer läuft'
    },
    table: {
      domain: 'Domain',
      status: 'Status',
      account: 'Account',
      registered: 'Registriert'
    },
    empty: {
      title: 'Keine Domains gefunden',
      description: 'Es wurden keine Domains mit den aktuellen Filtern gefunden.'
    },
    pagination: {
      showing: 'Zeige {from} bis {to} von {total} Domains'
    },
    mailDeactivate: {
      sectionTitle: 'Admin-Aktionen',
      title: 'Mail-Hosting kündigen',
      description: 'Kündigt das Mail-Hosting dieser Domain ordentlich oder fristlos. Fristlos deaktiviert es zusätzlich alle Postfächer und sperrt E-Mail, bis die Sperre aufgehoben wird.',
      button: 'Mail-Hosting kündigen',
      dialogTitle: 'Mail-Hosting kündigen',
      dialogMessage: 'Wähle die Art der Kündigung. Endet ein Mail-Abo, bekommt der Kunde die Kündigung per E-Mail.',
      modeLabel: 'Art der Kündigung',
      mode: {
        notice: 'Ordentlich (§ 3.2 AGB).',
        cause: 'Fristlos aus wichtigem Grund (§ 3.5 AGB).'
      },
      modeHint: {
        notice: 'Der Vertrag endet einen Kalendermonat nach heute, E-Mail läuft bis dahin weiter. Nur für ein Mail-Abo, das noch abgerechnet wird.',
        cause: 'Der Vertrag endet heute, E-Mail wird sofort abgeschaltet und gesperrt. Die bezahlte Zeit nach heute wird taggenau erstattet.'
      },
      notForNonPayment: 'Nicht bei Zahlungsverzug: § 3.5 S. 1 AGB verlangt dafür Mahnung und Nachfrist.',
      noticeReasonLabel: 'Grund für den Kunden',
      noticeReasonHint: 'Was ist wann passiert, ohne rechtliche Wertung. Steht so in der Kündigung an den Kunden.',
      warningDateLabel: 'Datum der Abmahnung',
      warningDispensable: 'Abmahnung entbehrlich (Sicherheit / offensichtlich strafbare Inhalte)',
      warning: {
        notice: 'Das Mail-Abo wird zum Vertragsende gekündigt; die bezahlte Zeit danach wird erstattet.',
        cause: 'Ein laufendes Mail-Abo endet heute und alle Postfächer werden deaktiviert. Die Daten bleiben erhalten.'
      },
      reasonLabel: 'Interner Grund (Audit-Log)',
      reasonPlaceholder: 'Grund für die Kündigung...',
      confirm: 'Kündigen',
      success: 'Mail-Hosting gekündigt',
      stripeUnavailable: 'E-Mail ist abgeschaltet und gesperrt, aber das Mail-Abo konnte noch nicht beendet werden, weil die Zahlungsabwicklung nicht erreichbar war. Der stündliche Lauf beendet es.',
      errors: {
        modeRequired: 'Wähle, ob ordentlich oder fristlos gekündigt wird.',
        noticeReasonRequired: 'Eine fristlose Kündigung braucht den Grund für den Kunden.',
        warningRequired: 'Eine fristlose Kündigung braucht das Datum der Abmahnung, oder die Abmahnung muss entbehrlich sein.',
        noMailPlan: 'Diese Domain hat kein Mail-Abo, das noch abgerechnet wird. Ordentlich kündigen lässt sich hier nichts.',
        busy: 'Am Mail-Abo läuft gerade eine andere Änderung. Versuche es gleich noch einmal.',
        noticeStripeUnavailable: 'Die Zahlungsabwicklung war nicht erreichbar, es wurde nichts geändert. Versuche es noch einmal.'
      }
    },
    mailRelease: {
      title: 'Mail-Sperre aufheben',
      description: 'Hebt die Admin-Sperre auf. Postfächer werden nur wieder eingeschaltet, wenn die Domain E-Mail-berechtigt ist.',
      button: 'Sperre aufheben',
      dialogTitle: 'Mail-Sperre aufheben',
      dialogMessage: 'Die Admin-Sperre für E-Mail auf dieser Domain wird aufgehoben. Ist die Domain über Hosting, den Bestandskunden-Tarif oder ein laufendes Mail-Abo berechtigt, werden alle Postfächer wieder eingeschaltet, sonst bleibt E-Mail abgeschaltet.',
      reasonLabel: 'Grund',
      reasonPlaceholder: 'Grund für die Aufhebung...',
      confirm: 'Sperre aufheben',
      success: 'Mail-Sperre aufgehoben',
      notOnHold: 'Für diese Domain besteht keine Admin-Sperre, es gab nichts aufzuheben.',
      reenableFailed: 'Die Sperre ist aufgehoben, aber nicht alle Postfächer ließen sich einschalten. Der stündliche Lauf schaltet den Rest ein.',
      staysOff: 'Die Sperre ist aufgehoben, E-Mail bleibt aber abgeschaltet.',
      staysOffNoEntitlement: 'Die Sperre ist aufgehoben, E-Mail bleibt aber abgeschaltet, weil die Domain nicht E-Mail-berechtigt ist.',
      staysOffSuspended: 'Die Sperre ist aufgehoben, E-Mail bleibt aber abgeschaltet, solange die Domain gesperrt ist.'
    }
  },
  products: {
    title: 'Produktverwaltung',
    subtitle: 'Verwalte alle Produkte und Preise',
    loading: 'Produkte werden geladen...',
    editable: 'Produkte',
    editableSubtitle: 'Editierbare Produkte',
    system: 'System-Produkte',
    systemSubtitle: 'Nicht-editierbare Produkte',
    newProduct: 'Neues Produkt',
    search: 'Produkte suchen...',
    noFilterResults: 'Keine Produkte gefunden',
    resetFilters: 'Filter zurücksetzen',
    table: {
      name: 'Name',
      price: 'Preis',
      active: 'Aktiv',
      public: 'Public',
      empty: 'Keine Produkte vorhanden',
      toggleActive: 'Aktiv umschalten',
      togglePublic: 'Öffentlich umschalten'
    },
    notifications: {
      activeEnabled: '{name}: Aktiv aktiviert',
      activeDisabled: '{name}: Aktiv deaktiviert',
      publicEnabled: '{name}: Öffentlich aktiviert',
      publicDisabled: '{name}: Öffentlich deaktiviert'
    },
    edit: {
      newProduct: 'Neues Produkt',
      editProduct: 'Produkt bearbeiten',
      createProduct: 'Erstelle ein neues Produkt',
      loading: 'Produkt wird geladen...',
      save: 'Speichern',
      status: 'Status',
      active: 'Aktiv',
      activeDesc: 'Produkt ist verfügbar',
      public: 'Öffentlich',
      publicDesc: 'Sichtbar für alle',
      basicInfo: 'Grundinformationen',
      name: 'Name',
      namePlaceholder: 'Produktname eingeben...',
      slug: 'Slug',
      slugPlaceholder: 'produkt-slug',
      description: 'Beschreibung',
      descriptionPlaceholder: 'Produktbeschreibung eingeben...',
      paymentIntervals: 'Zahlungsintervalle',
      intervals: {
        monthly: 'Monatlich',
        quarterly: 'Vierteljährlich',
        halfAnnually: 'Halbjährlich',
        annually: 'Jährlich'
      },
      prices: 'Preise',
      pricesSaveFirst: 'Speichere das Produkt zuerst, um Preise hinzuzufügen',
      features: 'Features',
      featuresSaveFirst: 'Speichere das Produkt zuerst, um Features hinzuzufügen',
      featureKey: 'Key...',
      featureValue: 'Value...',
      deleteFeature: 'Feature löschen',
      addFeature: 'Feature hinzufügen',
      notifications: {
        updated: 'Produkt erfolgreich aktualisiert',
        created: 'Produkt erfolgreich erstellt',
        featureDuplicate: 'Feature "{key}" existiert bereits'
      }
    },
    prices: {
      newPrice: 'Neuer Preis',
      empty: 'Keine Preise vorhanden',
      standard: 'Standard',
      active: 'Aktiv',
      inactive: 'Inaktiv',
      modal: {
        newPrice: 'Neuer Preis',
        editPrice: 'Preis bearbeiten',
        active: 'Aktiv',
        standard: 'Standard',
        amount: 'Preis (in Cent)',
        amountPlaceholder: 'z.B. 999 für 9,99€',
        amountHint: 'Eingabe in Cent, z.B. 999 = 9,99€',
        currency: 'Währung',
        currencyPlaceholder: 'EUR',
        tax: 'Steuersatz',
        taxPlaceholder: 'z.B. 0.19 für 19%',
        taxHint: 'Als Dezimalzahl, z.B. 0.19 = 19%',
        description: 'Beschreibung',
        descriptionPlaceholder: 'Optionale Beschreibung...',
        cancel: 'Abbrechen',
        save: 'Speichern'
      },
      notifications: {
        saveFirst: 'Bitte speichere das Produkt zuerst, bevor du Preise hinzufügst',
        updated: 'Der Preis wurde erfolgreich aktualisiert',
        created: 'Der Preis wurde erfolgreich erstellt'
      }
    }
  },
  migration: {
    title: 'Domain-Migration',
    subtitle: 'Domains von INWX importieren',
    loading: 'Domains werden geladen...',
    stats: {
      available: 'Verfügbar',
      imported: 'Importiert',
      selected: 'Ausgewählt'
    },
    table: {
      domain: 'Domain',
      expiryDate: 'Ablaufdatum',
      status: 'Status',
      actions: 'Aktionen',
      search: 'Domain suchen...',
      selectAll: 'Alle auswählen',
      deselectAll: 'Keine auswählen',
      selectedCount: '{count} ausgewählt'
    },
    status: {
      available: 'Verfügbar',
      imported: 'Bereits importiert',
      cannotImport: 'Import nicht möglich'
    },
    actions: {
      validate: 'Validieren',
      import: 'Importieren',
      importSelected: 'Ausgewählte importieren',
      refresh: 'Aktualisieren'
    },
    import: {
      title: 'Domain importieren',
      titleBatch: 'Domains importieren',
      subtitle: 'Konfiguriere den Import',
      selectedDomains: 'Ausgewählte Domains',
      accountAssignment: 'Konto-Zuweisung',
      existingAccount: 'Bestehendem Konto zuweisen',
      newAccount: 'Neues Konto erstellen',
      searchAccount: 'Konto suchen (E-Mail oder Name)...',
      noAccountsFound: 'Keine Konten gefunden',
      selectAccount: 'Konto auswählen',
      subAccount: {
        title: 'Sub-Account Beziehung',
        enable: 'Als Sub-Account importieren',
        description: 'Erstellt eine Beziehung zwischen dem Zielkonto und einem übergeordneten Account.',
        parentAccount: 'Eltern-Account',
        searchParent: 'Eltern-Account suchen...',
        noAccounts: 'Keine Accounts gefunden',
        type: 'Beziehungstyp',
        billingMode: 'Abrechnungsmodus',
        billingShared: 'Gemeinsam',
        billingIndependent: 'Eigenständig'
      }
    },
    accountForm: {
      title: 'Neues Konto',
      email: 'E-Mail',
      emailPlaceholder: "email{'@'}beispiel.de",
      name: 'Vorname',
      namePlaceholder: 'Max',
      surname: 'Nachname',
      surnamePlaceholder: 'Mustermann',
      organization: 'Organisation',
      organizationPlaceholder: 'Firma GmbH (optional)',
      street: 'Straße und Hausnummer',
      streetPlaceholder: 'Musterstraße 123',
      addressLine2: 'Adresszusatz',
      addressLine2Placeholder: 'Gebäude, Etage, etc. (optional)',
      city: 'Stadt',
      cityPlaceholder: 'Berlin',
      postcode: 'PLZ',
      postcodePlaceholder: '12345',
      country: 'Land (ISO)',
      countryPlaceholder: 'DE',
      state: 'Bundesland',
      statePlaceholder: 'Berlin (optional)',
      stateSelect: 'Bundesland auswählen',
      countrySelect: 'Land auswählen',
      phone: 'Telefon',
      phonePlaceholder: '+49 123 456789',
      vatId: 'USt-IdNr.',
      vatIdPlaceholder: 'DE123456789 (optional)'
    },
    validation: {
      title: 'Validierung',
      validating: 'Validiere...',
      valid: 'Import möglich',
      invalid: 'Import nicht möglich',
      reason: 'Grund',
      existsInDb: 'Domain bereits im System',
      notInInwx: 'Domain nicht in INWX gefunden',
      allValid: 'Alle Domains können importiert werden',
      someInvalid: '{count} Domain(s) können nicht importiert werden',
      mustValidate: 'Bitte validiere zuerst'
    },
    results: {
      title: 'Import-Ergebnis',
      subtitle: 'Übersicht des Imports',
      summary: 'Zusammenfassung',
      total: 'Gesamt',
      successful: 'Erfolgreich',
      failed: 'Fehlgeschlagen',
      domainResults: 'Domain-Ergebnisse',
      success: 'Erfolgreich importiert',
      error: 'Fehler',
      viewDomain: 'Domain anzeigen',
      close: 'Schließen',
      importMore: 'Weitere importieren'
    },
    empty: {
      title: 'Keine Domains verfügbar',
      subtitle: 'Es sind keine Domains zum Import in INWX vorhanden.'
    },
    notifications: {
      importSuccess: 'Domain erfolgreich importiert',
      importSuccessBatch: '{count} Domain(s) erfolgreich importiert',
      importFailed: 'Import fehlgeschlagen',
      validationSuccess: 'Validierung erfolgreich',
      validationFailed: 'Validierung fehlgeschlagen',
      loadFailed: 'Domains konnten nicht geladen werden'
    }
  },
  features: {
    title: 'Feature Flags',
    subtitle: 'Funktionen aktivieren oder deaktivieren',
    newFlag: 'Neuer Flag',
    loading: 'Feature Flags werden geladen...',
    stats: {
      flags: 'Flags',
      active: 'Aktiv',
      inactive: 'Inaktiv',
      categories: 'Kategorien'
    },
    table: {
      title: 'Feature Flags',
      subtitle: '{count} Flags in {categories} Kategorien',
      search: 'Suchen...',
      expandAll: 'Alle öffnen',
      categoryFlags: '{count} Flags',
      active: 'Aktiv',
      inactive: 'Inaktiv',
      edit: 'Bearbeiten',
      delete: 'Löschen'
    },
    empty: {
      title: 'Keine Feature Flags',
      subtitle: 'Erstelle einen neuen Flag um zu beginnen',
      noResults: 'Keine Ergebnisse',
      noResultsQuery: 'Keine Flags gefunden für "{query}"'
    },
    notifications: {
      enabled: '{name}: Aktiviert',
      disabled: '{name}: Deaktiviert',
      deleted: '{category}.{name} wurde gelöscht'
    },
    confirmDelete: 'Flag "{category}.{name}" wirklich löschen?',
    edit: {
      newFlag: 'Neuer Flag',
      editFlag: 'Flag bearbeiten',
      createFlag: 'Neuen Feature Flag erstellen',
      editFlagData: 'Feature Flag bearbeiten',
      saveAndNew: 'Speichern & Neu',
      save: 'Speichern',
      flagDetails: 'Flag Details',
      category: 'Kategorie*',
      categoryPlaceholder: 'z.B. admin, support, tracking',
      categoryHint: 'Gruppierung für diesen Flag',
      name: 'Name*',
      namePlaceholder: 'z.B. ticketForm, productManagement',
      nameHint: 'Eindeutiger Bezeichner (camelCase empfohlen)',
      status: 'Status',
      enabled: 'Aktiviert',
      disabled: 'Deaktiviert',
      enabledHint: 'Feature ist sichtbar/aktiv',
      disabledHint: 'Feature ist versteckt/inaktiv',
      preview: 'Vorschau',
      previewCategory: 'kategorie',
      previewName: 'name',
      dangerZone: 'Gefahrenzone',
      deleteFlag: 'Flag löschen',
      deleteHint: 'Diese Aktion kann nicht rückgängig gemacht werden.',
      validation: {
        categoryRequired: 'Kategorie ist erforderlich',
        categoryFormat: 'Nur Buchstaben, Zahlen, - und _ erlaubt',
        nameRequired: 'Name ist erforderlich',
        nameFormat: 'Nur Buchstaben, Zahlen, - und _ erlaubt',
        validationError: 'Validierungsfehler',
        checkFields: 'Bitte überprüfe die markierten Felder'
      },
      notifications: {
        created: 'Flag erstellt',
        updated: 'Flag aktualisiert',
        deleted: '{category}.{name} wurde gelöscht'
      },
      confirmDelete: 'Flag "{category}.{name}" wirklich löschen?'
    }
  },
  storage: {
    title: 'Speicher-Buckets',
    subtitle: 'Alle S3-Speicher-Buckets kontoübergreifend verwalten',
    searchPlaceholder: 'Bucket-Name oder Account-ID suchen...',
    empty: 'Keine Speicher-Buckets',
    emptyDescription: 'Es gibt derzeit keine Speicher-Buckets im System.',
    columns: {
      name: 'Name',
      region: 'Region',
      account: 'Account',
      status: 'Status',
      public: 'Öffentlich',
      storage: 'Speicher',
      objects: 'Objekte',
      created: 'Erstellt'
    },
    publicYes: 'Öffentlich',
    publicNo: 'Privat',
    actions: {
      suspend: 'Sperren',
      unsuspend: 'Entsperren',
      suspendSuccess: 'Bucket gesperrt',
      unsuspendSuccess: 'Bucket entsperrt',
      error: 'Aktion fehlgeschlagen'
    }
  },
  subAccounts: {
    title: 'Sub-Accounts',
    subtitle: 'Unterkonten und Beziehungen für diesen Benutzer',
    childrenTitle: 'Unterkonten (als Eltern-Account)',
    parentsTitle: 'Eltern-Accounts (als Unterkonto)',
    addRelationship: 'Beziehung hinzufügen',
    editRelationship: 'Beziehung bearbeiten',
    loadError: 'Die Sub-Accounts konnten nicht geladen werden.',
    retry: 'Erneut versuchen',
    deleteRelationship: 'Beziehung entfernen',
    noRelationships: 'Keine Beziehungen',
    noRelationshipsDescription: 'Dieser Account hat keine Sub-Account-Beziehungen.',
    confirmDelete: 'Beziehung zu {account} wirklich entfernen?',
    billingShared: 'Gemeinsame Abrechnung',
    billingIndependent: 'Eigene Abrechnung',
    status: {
      active: 'Aktiv',
      pending: 'Ausstehend',
      deactivated: 'Deaktiviert',
      expired: 'Abgelaufen',
      revoked: 'Zurückgezogen',
      awaitingAcceptance: 'Wartet auf Bestätigung'
    },
    types: {
      team: 'Team',
      reseller: 'Reseller'
    },
    billing: {
      shared: 'Gemeinsam (Eltern-Account)',
      independent: 'Eigenständig'
    },
    form: {
      childAccount: 'Unterkonto',
      searchAccount: 'Account suchen...',
      type: 'Beziehungstyp',
      billingMode: 'Abrechnungsmodus',
      label: 'Label',
      labelPlaceholder: 'Optionale Bezeichnung...',
      teamRole: 'Team-Rolle'
    },
    notifications: {
      created: 'Beziehung erstellt',
      createdMessage: 'Die Sub-Account-Beziehung wurde erfolgreich erstellt.',
      deleted: 'Beziehung entfernt',
      deletedMessage: 'Die Sub-Account-Beziehung wurde entfernt.',
      updated: 'Beziehung aktualisiert',
      updatedMessage: 'Die Sub-Account-Beziehung wurde aktualisiert.'
    }
  },
  registry: {
    title: 'Container Registry',
    subtitle: 'Registry-Konten verwalten',
    searchPlaceholder: 'Nach Namespace, E-Mail oder Account-ID suchen...',
    empty: 'Keine Registry-Konten',
    columns: {
      slug: 'Namespace',
      account: 'Account',
      region: 'Region',
      status: 'Status',
      storage: 'Speicher',
      created: 'Erstellt'
    },
    statuses: {
      active: 'aktiv',
      suspended: 'gesperrt',
      deactivated: 'deaktiviert',
      quota_exceeded: 'Speicher voll'
    },
    actions: {
      suspend: 'Sperren',
      suspendConfirm: 'Diese Registry sperren? Docker-Authentifizierung wird blockiert.',
      suspendSuccess: 'Registry gesperrt',
      unsuspend: 'Entsperren',
      unsuspendConfirm: 'Diese Registry entsperren?',
      unsuspendSuccess: 'Registry entsperrt'
    },
    detail: {
      notFound: 'Registry nicht gefunden',
      notFoundDescription: 'Die angeforderte Registry-Konfiguration konnte nicht gefunden werden.',
      backToList: 'Zurück zur Liste',
      registryInfo: 'Registry-Info',
      accountInfo: 'Account',
      billing: 'Abrechnung / Stripe',
      noBilling: 'Keine Stripe-Abrechnung konfiguriert',
      usage: 'Aktuelle Nutzung',
      noUsage: 'Keine Nutzungsdaten verfügbar',
      tokens: 'Zugriffstoken',
      noTokens: 'Keine Zugriffstoken',
      cleanupRules: 'Bereinigungsregeln',
      noCleanupRules: 'Keine Bereinigungsregeln konfiguriert',
      fields: {
        status: 'Status',
        region: 'Region',
        shard: 'Shard',
        slug: 'Namespace',
        storageQuota: 'Speicherkontingent',
        created: 'Erstellt',
        accountEmail: 'E-Mail',
        accountId: 'Account-ID',
        stripeSubscription: 'Abonnement',
        stripeStorageItem: 'Speicher-Posten',
        stripeEgressItem: 'Egress-Posten',
        storageUsed: 'Speicher belegt',
        egressUsed: 'Egress',
        pullCount: 'Pulls',
        pushCount: 'Pushes',
        period: 'Zeitraum',
        reportedToStripe: 'An Stripe gemeldet'
      },
      pullOnly: 'Nur Pull',
      tokenColumns: {
        name: 'Name',
        prefix: 'Präfix',
        active: 'Aktiv',
        scopes: 'Berechtigungen',
        created: 'Erstellt',
        lastUsed: 'Zuletzt verwendet',
        expires: 'Läuft ab'
      },
      ruleColumns: {
        repository: 'Repository',
        ruleType: 'Regeltyp',
        value: 'Wert',
        keepPatterns: 'Behalte-Muster',
        deletePatterns: 'Lösch-Muster',
        enabled: 'Aktiv'
      }
    }
  },
  kubernetes: {
    title: 'Kubernetes-Tenants',
    subtitle: 'Alle Kubernetes-Tenants und Namespaces verwalten',
    searchPlaceholder: 'Namespace oder E-Mail suchen...',
    status: {
      all: 'Alle',
      provisioning: 'Provisionierung',
      active: 'Aktiv',
      failed: 'Fehlgeschlagen',
      deprovisioning: 'Deprovisionierung',
      deprovisioned: 'Deprovisioniert'
    },
    table: {
      namespace: 'Namespace',
      status: 'Status',
      account: 'Account',
      product: 'Paket',
      provisioned: 'Provisioniert',
      gitRepo: 'Git-Repository'
    },
    empty: {
      title: 'Keine Tenants gefunden',
      description: 'Es wurden keine Kubernetes-Tenants mit den aktuellen Filtern gefunden.'
    },
    pagination: {
      showing: 'Zeige {from} bis {to} von {total} Tenants'
    },
    detail: {
      back: 'Zurück zur Tenant-Liste',
      tabs: {
        config: 'Konfiguration',
        live: 'Live-Daten',
        usage: 'Nutzung',
        domains: 'Domains',
        actions: 'Aktionen'
      },
      config: {
        title: 'Tenant-Konfiguration',
        namespace: 'Namespace',
        status: 'Status',
        errorMessage: 'Fehlermeldung',
        provisionedAt: 'Provisioniert am',
        gitRepo: 'Git-Repository',
        gitPath: 'Git-Pfad',
        gitRevision: 'Git-Revision',
        selfHeal: 'Self-Heal',
        yes: 'Ja',
        no: 'Nein',
        syncStatus: 'Sync-Status',
        healthStatus: 'Health-Status',
        spendingCap: 'Ausgabenlimit'
      },
      live: {
        overview: 'Übersicht',
        workloads: 'Workloads',
        pods: 'Pods',
        events: 'Events',
        name: 'Name',
        kind: 'Art',
        ready: 'Bereit',
        age: 'Alter',
        status: 'Status',
        restarts: 'Neustarts',
        type: 'Typ',
        reason: 'Grund',
        object: 'Objekt',
        message: 'Nachricht',
        count: 'Anzahl',
        empty: 'Keine Live-Daten verfügbar',
        noUsage: 'Keine Nutzungsdaten verfügbar',
        verified: 'Verifiziert',
        pending: 'Ausstehend',
        notFound: 'Tenant nicht gefunden'
      },
      usage: {
        title: 'Aktuelle Nutzung',
        cpuCoreHours: 'CPU (Core-Stunden)',
        memoryGibHours: 'Speicher (GiB-Stunden)',
        storageGib: 'Storage (GiB)',
        egressGib: 'Egress (GiB)',
        projectedBill: 'Voraussichtliche Rechnung',
        cpuCents: 'CPU',
        memoryCents: 'Speicher',
        storageCents: 'Storage',
        egressCents: 'Egress',
        baseFee: 'Grundgebühr',
        total: 'Gesamt',
        period: 'Abrechnungszeitraum',
        daysElapsed: 'Tage verstrichen'
      },
      domains: {
        title: 'Tenant-Domains',
        domain: 'Domain',
        verified: 'Verifiziert',
        verifiedAt: 'Verifiziert am',
        token: 'Token',
        created: 'Erstellt',
        empty: 'Keine Domains',
        verify: 'Verifizieren',
        delete: 'Löschen',
        verifySuccess: 'Domain verifiziert',
        deleteSuccess: 'Domain gelöscht',
        confirmDelete: 'Domain "{domain}" wirklich löschen?'
      },
      actions: {
        title: 'Tenant-Aktionen',
        deprovision: 'Deprovisionieren',
        deprovisionDesc: 'Tenant und alle Ressourcen aus dem Cluster entfernen.',
        deprovisionConfirm: 'Tenant wirklich deprovisionieren? Diese Aktion kann nicht rückgängig gemacht werden.',
        deprovisionSuccess: 'Tenant deprovisioniert',
        syncUsage: 'Nutzung synchronisieren',
        syncUsageDesc: 'Nutzungsdaten aller Tenants synchronisieren.',
        syncSuccess: 'Nutzung synchronisiert',
        regenerateKubeconfig: 'Kubeconfig regenerieren',
        regenerateDesc: 'Neue Kubeconfig generieren (die alte wird dadurch ungültig).',
        regenerateConfirm: 'Kubeconfig wirklich regenerieren? Die aktuelle Kubeconfig wird ungültig.',
        regenerateSuccess: 'Kubeconfig regeneriert',
        provision: 'Provisionieren',
        provisionDesc: 'Tenant manuell provisionieren.',
        provisionSuccess: 'Tenant provisioniert',
        error: 'Aktion fehlgeschlagen'
      }
    },
    usageOverview: {
      title: 'Kubernetes-Nutzung',
      subtitle: 'Nutzungsübersicht aller Tenants',
      table: {
        namespace: 'Namespace',
        account: 'Account',
        cpu: 'CPU (h)',
        memory: 'RAM (h)',
        storage: 'Storage (GiB)',
        egress: 'Egress (GiB)',
        projected: 'Prognose',
        spendingCap: 'Limit'
      },
      empty: {
        title: 'Keine aktiven Tenants',
        description: 'Es gibt derzeit keine aktiven Kubernetes-Tenants.'
      },
      pagination: {
        showing: 'Zeige {from} bis {to} von {total} Tenants'
      }
    },
    domains: {
      title: 'Kubernetes-Domains',
      subtitle: 'Alle K8s-Domains kontoübergreifend verwalten',
      searchPlaceholder: 'Domain suchen...',
      filter: {
        all: 'Alle',
        verified: 'Verifiziert',
        pending: 'Ausstehend'
      },
      table: {
        domain: 'Domain',
        account: 'Account',
        verified: 'Status',
        created: 'Erstellt'
      },
      verifiedLabel: 'Verifiziert',
      pendingLabel: 'Ausstehend',
      empty: {
        title: 'Keine Domains gefunden',
        description: 'Es wurden keine K8s-Domains mit den aktuellen Filtern gefunden.'
      },
      pagination: {
        showing: 'Zeige {from} bis {to} von {total} Domains'
      }
    }
  },
  hosting: {
    title: 'Webhosting',
    subtitle: 'Alle Webhosting-Sites accountübergreifend verwalten',
    searchPlaceholder: 'Name, Domain oder Account suchen...',
    status: {
      all: 'Alle',
      provisioning: 'Provisionierung',
      active: 'Aktiv',
      failed: 'Fehlgeschlagen',
      suspended: 'Suspendiert',
      deprovisioned: 'Deprovisioniert'
    },
    legacy: {
      all: 'Alle Sites',
      migrated: 'Migriert',
      fresh: 'Neu angelegt'
    },
    table: {
      name: 'Name',
      status: 'Status',
      account: 'Account',
      product: 'Paket',
      quota: 'Quota',
      domain: 'Primärdomain',
      created: 'Erstellt'
    },
    empty: {
      title: 'Keine Sites gefunden',
      description: 'Es wurden keine Hosting-Sites mit den aktuellen Filtern gefunden.'
    },
    pagination: {
      showing: 'Zeige {from} bis {to} von {total} Sites'
    },
    detail: {
      title: 'Site-Detail',
      subtitle: 'Admin-Ansicht einer einzelnen Hosting-Site',
      notFound: 'Site nicht gefunden',
      k8sStatus: 'Kubernetes-Status',
      noK8sStatus: 'Keine Live-Daten verfügbar.',
      noDomains: 'Keine Domains verknüpft.',
      noDatabases: 'Keine Datenbanken konfiguriert.',
      tabs: {
        overview: 'Übersicht',
        domains: 'Domains',
        databases: 'Datenbanken',
        actions: 'Aktionen'
      },
      fields: {
        owner: 'Inhaber',
        product: 'Paket',
        runtime: 'Runtime',
        quota: 'Quota',
        sftp: 'SFTP-User',
        created: 'Erstellt',
        trialEnd: 'Trial endet'
      },
      actions: {
        impersonate: 'Als Kunde anmelden',
        restart: 'Pod neu starten',
        restartDesc: 'Rollt das Deployment neu aus (Downtime ~2s).',
        reconcile: 'Site CR abgleichen',
        reconcileDesc: 'Schreibt Spec aus der Datenbank zurück in das Cluster.',
        rotateSftp: 'SFTP-Passwort rotieren',
        rotateSftpDesc: 'Erzeugt ein neues Passwort und zeigt es einmalig an.',
        newPassword: 'Neues Passwort',
        delete: 'Site deprovisionieren',
        deleteDesc: 'Entfernt Site CR und markiert die Site als deprovisioniert. Daten werden aufbewahrt.',
        deleteConfirmTitle: 'Site wirklich deprovisionieren?',
        deleteConfirmBody: 'Zur Bestätigung den Sitenamen „{name}" eingeben.'
      },
      notify: {
        restartSuccess: 'Neustart ausgelöst',
        reconcileSuccess: 'Reconcile ausgelöst',
        rotateSuccess: 'SFTP-Passwort rotiert',
        deleteSuccess: 'Site deprovisioniert'
      }
    }
  },
  accountSplit: {
    title: 'Account-Splits',
    subtitle: 'Admin-gesteuerte Massen-Übertragung von Assets zwischen Accounts',
    status: {
      draft: 'Entwurf',
      dry_run_ok: 'Dry-run OK',
      executing: 'Wird ausgeführt',
      partial_failure: 'Teilweise fehlgeschlagen',
      completed: 'Abgeschlossen',
      aborted: 'Abgebrochen'
    },
    assetType: {
      subscription: 'Abonnement',
      domain: 'Domain',
      handle: 'Handle',
      hosting_site: 'Hosting-Site',
      mailbox: 'Postfach'
    },
    itemStatus: {
      pending: 'Ausstehend',
      in_progress: 'In Bearbeitung',
      succeeded: 'Erfolgreich',
      failed: 'Fehlgeschlagen',
      skipped: 'Übersprungen'
    },
    targetMode: {
      existing_account: 'Bestehender Account',
      new_account: 'Neuer Account'
    },
    actions: {
      create: 'Neuer Split',
      dryRun: 'Dry-run starten',
      execute: 'Ausführen',
      resume: 'Fortsetzen',
      abort: 'Abbrechen',
      save: 'Entwurf speichern',
      cancel: 'Abbrechen',
      addItem: 'Asset hinzufügen',
      removeItem: 'Entfernen',
      open: 'Öffnen',
      back: 'Zurück',
      reopenDryRun: 'Dry-run erneut öffnen',
      confirmExecute: 'Bestätigen & Ausführen'
    },
    confirm: {
      execute: 'Split ausführen? Assets werden auf den Ziel-Account übertragen.',
      abort: 'Split abbrechen? Ein automatisches Rollback wird nicht durchgeführt.',
      dryRunRequired: 'Vor der Ausführung muss ein erfolgreicher Dry-run durchgeführt werden.',
      abortReason: 'Grund (optional)',
      abortReasonPlaceholder: 'Warum wird dieser Split abgebrochen?'
    },
    dryRun: {
      title: 'Dry-run-Ergebnis',
      vatDelta: 'MwSt.-Differenz',
      warnings: 'Warnungen',
      plannedActions: 'Geplante Aktionen',
      openInvoices: 'Offene Rechnungen',
      beforeTotal: 'Aktueller Betrag',
      afterTotal: 'Nach Split',
      noChanges: 'Keine offenen Rechnungen betroffen.',
      noItems: 'Keine Items für diesen Split geplant.',
      noWarnings: 'Keine Warnungen.'
    },
    builder: {
      sourceLabel: 'Quell-Account',
      targetLabel: 'Ziel-Account',
      assetPicker: 'Assets auswählen',
      draftSaved: 'Entwurf gespeichert',
      selectAccount: 'Account auswählen',
      searchPlaceholder: 'Suche nach E-Mail, Name oder Organisation',
      noResults: 'Keine Accounts passen zu deiner Suche.',
      clearSelection: 'Auswahl löschen',
      assetSubscriptions: 'Abonnements',
      assetDomains: 'Domains',
      assetSites: 'Hosting-Sites',
      assetMailboxes: 'Postfächer',
      assetHandles: 'Handles',
      noAssets: 'Keine Assets dieses Typs für den Quell-Account gefunden.',
      notImplemented: 'Postfächer können nach dem Split über die API hinzugefügt werden — die UI-Auswahl ist noch nicht implementiert.',
      newAccountIntro: 'Neuer Account wird bei Ausführung erstellt. Stripe-Kunde und DB-Eintrag werden beim ersten Execute angelegt.',
      notesLabel: 'Operator-Notizen',
      notesPlaceholder: 'Warum wird dieser Split angelegt?',
      pickSourceFirst: 'Zuerst einen Quell-Account auswählen.',
      saveBeforeDryRun: 'Entwurf wird vor Dry-run gespeichert...',
      newAccountForm: {
        type: 'Typ',
        typePerson: 'Person',
        typeOrganization: 'Organisation',
        language: 'Sprache',
        email: 'E-Mail',
        firstName: 'Vorname',
        lastName: 'Nachname',
        organization: 'Firma',
        line1: 'Straße (Zeile 1)',
        line2: 'Zeile 2',
        postcode: 'PLZ',
        city: 'Stadt',
        countryIso: 'Land (ISO)',
        phone: 'Telefon'
      }
    },
    home: {
      columnId: 'ID',
      columnSource: 'Quelle',
      columnTarget: 'Ziel',
      columnStatus: 'Status',
      columnCreated: 'Erstellt',
      columnActions: '',
      emptyTitle: 'Noch keine Splits',
      emptyHint: 'Erstelle einen, um einen Account aufzuteilen.'
    },
    detail: {
      sectionMeta: 'Split-Metadaten',
      sectionItems: 'Items',
      sourceAccount: 'Quell-Account',
      targetAccount: 'Ziel-Account',
      createdAt: 'Erstellt',
      updatedAt: 'Aktualisiert',
      executedAt: 'Ausgeführt',
      notes: 'Notizen',
      newAccountPayload: 'Neuer-Account-Payload',
      failureReason: 'Fehlergrund',
      columnId: 'ID',
      columnType: 'Asset-Typ',
      columnAssetId: 'Asset-ID',
      columnAttempts: 'Versuche',
      columnError: 'Fehler',
      columnStarted: 'Gestartet',
      columnFinished: 'Beendet',
      noItems: 'Keine Items in diesem Split.',
      beforeSnapshot: 'Snapshot vorher',
      afterSnapshot: 'Snapshot nachher',
      pollingNotice: 'Ausführung läuft — wird alle 3s aktualisiert.'
    },
    notify: {
      created: 'Split erstellt',
      draftSaved: 'Entwurf gespeichert',
      itemAdded: 'Asset hinzugefügt',
      itemRemoved: 'Asset entfernt',
      dryRunSuccess: 'Dry-run abgeschlossen',
      executeStarted: 'Ausführung gestartet',
      executeCompleted: 'Split erfolgreich abgeschlossen',
      executePartial: 'Split teilweise abgeschlossen — einige Assets konnten nicht übertragen werden',
      resumeStarted: 'Fortsetzung gestartet',
      aborted: 'Split abgebrochen'
    },
    errors: {
      notFound: 'Split nicht gefunden',
      notDraftable: 'Split ist nicht mehr bearbeitbar',
      paidInvoiceUnsupported: 'Bezahlte Rechnungen können in v1 nicht aufgeteilt werden – bitte manuell trennen',
      busyOrWrongState: 'Split ist beschäftigt oder im falschen Status für diese Aktion',
      validation: 'Ungültige Anfrage',
      generic: 'Ein unerwarteter Fehler ist aufgetreten'
    }
  },
  roles: {
    title: 'Rollen',
    subtitle: 'System-Rollen und Berechtigungen verwalten',
    loading: 'Rollen werden geladen...',
    empty: 'Keine Rollen definiert',
    emptyDescription: 'Im System sind keine Rollen konfiguriert.',
    columns: {
      name: 'Name',
      displayName: 'Anzeigename',
      description: 'Beschreibung',
      priority: 'Priorität',
      permissions: 'Berechtigungen',
      system: 'System'
    },
    systemBadge: 'System-Rolle',
    permissionCount: '{count} Berechtigung | {count} Berechtigungen',
    expandPermissions: 'Berechtigungen anzeigen',
    collapsePermissions: 'Berechtigungen ausblenden',
    userRoles: {
      title: 'Benutzer-Rollen',
      subtitle: 'Rollen für diesen Benutzer',
      noRoles: 'Keine Rollen zugewiesen',
      noRolesDescription: 'Dieser Benutzer hat keine speziellen Rollen.',
      assignRole: 'Rolle zuweisen',
      revokeRole: 'Rolle entziehen',
      grantedAt: 'Zugewiesen am',
      expiresAt: 'Läuft ab am',
      never: 'Nie',
      selectRole: 'Rolle auswählen',
      expiryDate: 'Ablaufdatum',
      noExpiry: 'Kein Ablaufdatum',
      confirmRevoke: 'Rolle "{role}" wirklich entziehen?',
      notifications: {
        assigned: 'Rolle zugewiesen',
        assignedMessage: '{role} wurde dem Benutzer zugewiesen.',
        revoked: 'Rolle entzogen',
        revokedMessage: '{role} wurde dem Benutzer entzogen.'
      }
    }
  }
} as const
